import ListBuckets from './Buckets';

export default ListBuckets;
